<template>
  <div id="app">
    <!-- <transition :name="$route.meta.noAnimation ? '' : 'slide'"> -->
      <keep-alive :include="['trainingCenter']">
        <router-view class="router-view" v-if="$route.meta.keepAlive" :key="cacheKey" />
      </keep-alive>
      <router-view class="router-view" v-if="!$route.meta.keepAlive"/>
    <!-- </transition> -->
    <!-- v-if：隐藏时彻底卸载，避免与游戏共用 WebGL/Spine -->
    <ThreeSprite v-if="isSprite"/>
    <CheckUpdate />
  </div>
</template>
<script>
import CheckUpdate from '@/components/update.vue'

export default {
  name: 'App',
  components: {
     ThreeSprite: () => import('@/components/sprite.vue'),
     CheckUpdate
  },

  data() {
    return {
      cacheKey: 'cacheKey',
      isSprite: 0
    }
  },
  provide() {
    return {
      refreshKey: this.refreshKey,
      switchSpriteState: this.switchSpriteState
    }
  },
  mounted() {},
  methods: {
    refreshKey() {
    this.cacheKey = new Date().getTime()
   },
   switchSpriteState(status) {
    this.isSprite = status
   }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<style>
html,body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar {
    width: 6px;
    display: none;
  }

::-webkit-scrollbar-thumb {
    background: #99a9bf;
    border-radius: 20px;
  }
::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
.slide-enter-active {
  transition: all 0.3s ease-in-out;
}
.slide-enter {
  transform: translateX(100%);
}

/* 离开动画：向左侧滑出 */
.slide-leave-active {
  transition: all 1s ease-in-out;
  z-index: -22;
}
.slide-leave-to {
  transition: translateX(-100%);
}

/* .router-view {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
} */
</style>
